import React, { useEffect, useState } from 'react';
import { Flexer } from '../app/dashboard/elements/LayoutElements';
import { Button } from './Button';

//
// Written with Claude, in case it's weird.
//

export interface PagingData {
    startAt: number;
    maxResults: number;
    total: number;
}

interface PagingWidgetProps {
    data: PagingData;
    onPageChange: (newStartAt: number) => void;
}

export const PageButtonStrip = React.memo<PagingWidgetProps>(({ data, onPageChange }) => {
    const [prevValidData, setPrevValidData] = useState<PagingData>({ startAt: 0, maxResults: 0, total: 0 });

    useEffect(() => {
        if (data !== null) {
            setPrevValidData(data);
        }
    }, [data]);

    const { startAt, maxResults, total } = data ?? prevValidData ?? {};

    const currentPage = Math.floor(startAt / maxResults) + 1;
    const totalPages = Math.ceil(total / maxResults);

    const handlePrevious = () => {
        if (startAt > 0) {
            onPageChange(Math.max(0, startAt - maxResults));
        }
    };

    const handleNext = () => {
        if (startAt + maxResults < total) {
            onPageChange(startAt + maxResults);
        }
    };

    if (isNaN(currentPage) || isNaN(totalPages)) return null;
    if (totalPages <= 1) return null;

    return (
        <Flexer flex="row" center gap="1">
            <Button onAction={handlePrevious}>Previous</Button>
            <span>Page {currentPage} of {totalPages}</span>
            <Button onAction={handleNext}>Next</Button>
        </Flexer>
    );
});
